import { createThemeCompiler } from '../../../utils';

export const typographyThemeCompiler = createThemeCompiler(() => ({
    typography: {
        xSmall: { fontSize: '12px', fontWeight: 400, letterSpacing: '0.01em' },
        small: { fontSize: '14px', fontWeight: 400, letterSpacing: '0.01em' },
        lightSmall: { fontSize: '14px', fontWeight: 300, letterSpacing: '0.01em' },
        medium: { fontSize: '16px', fontWeight: 400, letterSpacing: '0.01em' },
        large: { fontSize: '18px', fontWeight: 400, letterSpacing: '0.01em' },
        xLarge: { fontSize: '20px', fontWeight: 400, letterSpacing: '0.01em' },
        sectionHeading: { fontSize: '18px', fontWeight: 500, letterSpacing: 'normal' },
        hero1: { fontSize: '62px', fontWeight: 100, letterSpacing: 'normal' },
        hero2: { fontSize: '52px', fontWeight: 100, letterSpacing: 'normal' },
        hero3: { fontSize: '42px', fontWeight: 300, letterSpacing: 'normal' },
        hero4: { fontSize: '32px', fontWeight: 300, letterSpacing: 'normal' },
        hero5: { fontSize: '28px', fontWeight: 400, letterSpacing: 'normal' },
        h1: { fontSize: '28px', fontWeight: 500, letterSpacing: 'normal' },
        h2: { fontSize: '24px', fontWeight: 500, letterSpacing: 'normal' },
        h3: { fontSize: '20px', fontWeight: 500, letterSpacing: 'normal' },
        h4: { fontSize: '18px', fontWeight: 500, letterSpacing: 'normal' },
        h5: { fontSize: '16px', fontWeight: 500, letterSpacing: 'normal' },
        h6: { fontSize: '14px', fontWeight: 500, letterSpacing: 'normal' }
    }
}));
